import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class FaseCultivoValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;

        if (!model.descricao) {
            this.showMessage(new Message('alert', 'msg-obrigatorio-descricao', true));
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }
        
        return validated;
    }

}